<template>
  <div class="modal mediaViewer" v-if="file">
    <div class="modal--backdrop" @click="dismiss()"></div>
    <div class="modal--content autoAdjust">
      <div class="modal--header">
        <h4>Preview: {{ file.name }}</h4>
        <IconComponent
          path=""
          className="closebtn"
          icon="close-times.svg"
          @click="dismiss"
        />
      </div>
      <div class="modal--body" v-if="url">
        <div class="shimmer_container" v-if="!isLoaded">
          <LogoShimmerComponent />
        </div>
        <template v-if="isWidgetShown">
          <iframe
            :src="url"
            @load="isLoaded = true"
            @error="reload()"
            loading="lazy"
            v-if="isDocViewer"
            frameborder="0"
          ></iframe>
          <figure v-else-if="isImageViewer || isVideoViewer">
            <img
              @error="reload()"
              @load="isLoaded = true"
              :src="url"
              v-if="isImageViewer"
            />
            <video
              @load="isLoaded = true"
              @error="reload()"
              controls
              v-if="isVideoViewer"
              style="width: 100%"
            >
              <source :src="url" />
            </video>
          </figure>
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { popModal } from "jenesius-vue-modal";
import { defineComponent, onMounted, ref } from "vue";
import IconComponent from "@/components/IconComponent.vue";
import LogoShimmerComponent from "../LogoShimmerComponent.vue";

export default defineComponent({
  props: {
    file: {
      type: Object,
      required: true,
    },
    attachmentUrl: {
      type: String,
      required: true,
    },
  },
  components: {
    IconComponent,
    LogoShimmerComponent,
  },
  setup(props) {
    const isLoaded = ref<boolean>(false);
    const dismiss = popModal;
    const isImageViewer = ref<boolean>(false);
    const isVideoViewer = ref<boolean>(false);
    const isDocViewer = ref<boolean>(false);
    const url = ref<string>();
    const isWidgetShown = ref<boolean>(false);

    onMounted(() => {
      url.value = props.attachmentUrl;
      if (props.file) {
        props.file.extension = props.file.name
          .slice(props.file.name.lastIndexOf(".") + 1)
          .toLowerCase();
        if (
          props.file.extension == "jpg" ||
          props.file.extension == "jpeg" ||
          props.file.extension == "png" ||
          props.file.extension == "gif" ||
          props.file.extension == "jfif"
        ) {
          isImageViewer.value = true;
        } else if (
          props.file.extension == "mp4" ||
          props.file.extension == "mov" ||
          props.file.extension == "3gp" ||
          props.file.extension == "avi"
        ) {
          isVideoViewer.value = true;
        } else {
          url.value = getGDocViewer(url.value);
          isDocViewer.value = true;
        }
      } else {
        isImageViewer.value = true;
      }
      reload();
    });

    const getGDocViewer = (url: string) => {
      return `https://docs.google.com/viewer?embedded=true&url=${encodeURI(
        url
      )}`;
    };

    const reload = () => {
      isWidgetShown.value = false;
      setTimeout(() => {
        isWidgetShown.value = true;
      }, 100);
    };

    return {
      url,
      isWidgetShown,
      reload,
      isLoaded,
      isImageViewer,
      isVideoViewer,
      isDocViewer,
      dismiss,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "./media-viewer";
</style>